export enum QMSTicket {
    Name = 'QMSTicket',
    SubscribeToQmsTiket = 'SubscribeToQmsTiket',
    ReceiveTicket = 'ReceiveTicket',
    RemoveTicket = 'RemoveTicket',
    UpdatedTickets = 'UpdatedTickets',
    CurrentTicket = 'CurrentTicket'
}
